<template>
  <div></div>
</template>

<script>
import axios from "axios";

export default {
  async created() {
    const code = this.$route.query.code;

    const url = `${process.env.VUE_APP_CONNECT}/users/token/decode`;
    const res = await axios.post(url, { code });

    const value = res.data.data;

    if (!value) {
      this.$router.replace({ path: "/" });
      return;
    } else {
      sessionStorage.setItem("aiepinfo", value);
      this.$router.replace({ path: "/" });
      return;
    }
  },
};
</script>

<style>
</style>